module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("As a teenager, the Anglo-Irish painter Francis Bacon was sent to Weimar Berlin with an uncle, but that fact has been surrounded by pure fiction. The characters and events "), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("are wholly imaginary and any resemblance to persons living or dead is truly coincidental. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3962a5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/Law_NightsInBerlin_3P_MD4.vue
// module id = 84
// module chunks = 0